import { ActivityEntityName } from '../shared/activity.entity.name';

export interface AssetLinkRequest {

    /** @description Entity ID */
    entityId: string;

    /** @description Entity Type */
    entityType?: ActivityEntityName;

    assetIds: string[];
    siteId?: string;
    customerId?: string;
    assetLinkId?: string;
}

export interface AssetReparentRequest {
    assetId: string;
    newParentId: string;
    newParentType: AssetParentType;
}

export enum AssetParentType {
    Asset = 'asset',
    Site = 'site'
}
